// src/lib/analytics.js
// Jedno miejsce do pomiaru lejka: wejście z Google → demo → cennik → zakup.

export const GA4_ID = process.env.REACT_APP_GA4_ID || '';
export const ADS_ID = process.env.REACT_APP_GOOGLE_ADS_ID || 'AW-16960208448';
export const ADS_PURCHASE_LABEL =
  process.env.REACT_APP_ADS_PURCHASE_LABEL || '5-_iCLe9grEaEMD8oJc_';

const gtag = (...args) => {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  if (typeof window.gtag === 'function') {
    window.gtag(...args);
  } else {
    window.dataLayer.push(args);
  }
};

/** Zwykłe zdarzenie (kliknięcia CTA, start demo itd.). */
export const trackEvent = (name, params = {}) => {
  try {
    gtag('event', name, params);
  } catch (e) {
    /* pomiar nigdy nie może wywrócić strony */
  }
};

/** Odsłona przy zmianie trasy w SPA - bez tego GA4 widzi tylko wejście. */
export const trackPageView = path => {
  if (!GA4_ID) return;
  trackEvent('page_view', {
    page_path: path,
    page_location: typeof window !== 'undefined' ? window.location.href : undefined,
    page_title: typeof document !== 'undefined' ? document.title : undefined,
    send_to: GA4_ID,
  });
};

/** Klucz w sessionStorage - wartość zamówienia przenoszona na stronę podziękowania. */
const PENDING_ORDER_KEY = 'pilotuje_pending_order';

export const rememberPendingOrder = order => {
  try {
    sessionStorage.setItem(PENDING_ORDER_KEY, JSON.stringify({ ...order, ts: Date.now() }));
  } catch (e) {
    /* prywatny tryb przeglądarki - trudno */
  }
};

export const readPendingOrder = () => {
  try {
    const raw = sessionStorage.getItem(PENDING_ORDER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
};

export const clearPendingOrder = () => {
  try {
    sessionStorage.removeItem(PENDING_ORDER_KEY);
  } catch (e) {
    /* ignore */
  }
};

export const trackBeginCheckout = ({ value, days }) => {
  trackEvent('begin_checkout', {
    currency: 'PLN',
    value,
    items: [
      {
        item_id: `dostep_${days}d`,
        item_name: `Dostęp do testów dla pilotów - ${days} dni`,
        price: value,
        quantity: 1,
      },
    ],
  });
};

/** Zakup: GA4 + konwersja Google Ads z prawdziwą wartością zamówienia. */
export const trackPurchase = ({ value, days, transactionId }) => {
  const amount = Number(value) || 0;

  trackEvent('purchase', {
    transaction_id: transactionId,
    currency: 'PLN',
    value: amount,
    items: [
      {
        item_id: `dostep_${days}d`,
        item_name: `Dostęp do testów dla pilotów - ${days} dni`,
        price: amount,
        quantity: 1,
      },
    ],
  });

  trackEvent('conversion', {
    send_to: `${ADS_ID}/${ADS_PURCHASE_LABEL}`,
    value: amount,
    currency: 'PLN',
    transaction_id: transactionId,
  });
};
